var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5ZM12 3C7.02944 3 3 7.02944 3 12C3 16.4568 6.24046 20.1537 10.4932 20.8711V15.2402H8.25V12.5176H10.4932V10.499C10.4933 8.17053 11.8489 6.89941 13.8359 6.89941C14.7889 6.89945 15.5953 6.98447 15.8369 7.0127V9.4541H14.4668C13.3927 9.4541 13.1777 9.99091 13.1777 10.7812V12.5176H15.7559L15.4189 15.2402H13.1777V20.9199C17.5915 20.3428 21 16.5712 21 12C21 7.02944 16.9706 3 12 3Z",
    fill: "#FC4C02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.4841a9905ba9435f33f28e0eb399bfd9.svg";
export { ForwardRef as ReactComponent };